import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/shad/ui/dialog'
import React, { useState } from 'react'
import { CloseIcon } from '../../icons/general'
import Image from '../Image/Image'


interface FileItemProps {
  /** The file object to display */
  path: string
  /** The index of the file in the array */
  index: number
  /** Function to call when remove button is clicked */
  onRemove: (index: number) => void
  /** Translation function (optional) */
  t?: (text: string) => string
  title: string; 
}

/**
 * FileItem component for displaying a file with thumbnail and remove button
 * Supports images and PDF files with different thumbnail displays and fullscreen viewing
 */
const ImagePathPreview: React.FC<FileItemProps> = ({
  path,
  index,
  onRemove,
  title, 
  t = (text: string) => text,
}) => {


  // State for dialog open/close
  const [dialogOpen, setDialogOpen] = useState(false)

  return (
    <div className="flex items-center justify-between gap-2">
      <div className="flex items-center space-x-2">
        <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
          <DialogTrigger asChild>
            <div className="w-20 h-20 border rounded-md border-gray-300 overflow-hidden cursor-pointer hover:opacity-90 transition-opacity">
                <Image
                  path={path}
                  alt={`Document ${index + 1}`}
                  className="object-cover w-full h-full rounded-md"
              />
            </div>
          </DialogTrigger>
          <DialogContent className="max-w-4xl w-full p-1 sm:p-6">
            <DialogHeader className="mb-2">
              <DialogTitle>{title ?? path}</DialogTitle>
            </DialogHeader>
            <div className="w-full flex items-center justify-center">
              <Image path={path}                   alt={`Uploaded document ${index + 1}`}
 />
            </div>
          </DialogContent>
        </Dialog>
        <div>
          <div className="text-sm font-medium truncate max-w-xs">{title ?? path}</div>
          <button
            className="text-sm text-blue-500 hover:text-blue-600 mt-1"
            onClick={() => setDialogOpen(true)}
          >
            {t('View')}
          </button>
        </div>
      </div>
      <button
        className="flex items-center justify-center px-4 py-2 text-sm font-medium rounded-md border border-gray-300 hover:bg-gray-50"
        onClick={() => onRemove(index)}
      >
        {t('Remove')}
        <CloseIcon className="ml-2 text-red-500" />
      </button>
    </div>
  )
}

export {
  ImagePathPreview
}

